import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const objections = [{
  q: '“No soy bueno con Excel, ¿me va a servir?”',
  a: 'Sí. Las planillas ya vienen armadas con las fórmulas hechas: vos solo completás los casilleros en blanco. Si sabés escribir un número, sabés usarlas.'
}, {
  q: '“¿Es un curso largo que nunca voy a terminar?”',
  a: 'No. Es un kit de herramientas listas para usar. Lo descargás, lo abrís y ese mismo día ya podés armar tu primer presupuesto.'
}, {
  q: '“Ya tengo un sistema de gestión, ¿lo necesito?”',
  a: 'Los sistemas te registran lo que hacés, pero no te dicen cuánto te cuesta una hora de sillón ni te dan contratos ni material para explicarle el plan al paciente. El kit cubre justamente eso.'
}, {
  q: '“¿Y si tengo un consultorio chico?”',
  a: 'Mejor todavía. Cuanto más chica la estructura, más pesa cada hora perdida y cada material mal comprado. Todo es adaptable a un solo sillón.'
}, {
  q: '“¿Lo recibo enseguida?”',
  a: 'Sí. Es 100% digital: apenas se aprueba el pago te llega el acceso a tu mail para descargar todo, incluidos los bonos.'
}, {
  q: '“$21.999 me parece plata.”',
  a: 'Es menos de lo que facturás en una obturación. Con solo ajustar un precio mal calculado o evitar una compra cara de insumos, ya se pagó solo.'
}];
export function Objections() {
  const [open, setOpen] = useState<number | null>(null);
  return <section className="px-5 py-10" data-id="element-139" data-mp="o74iisk3msf0">
      <h2 className="text-center text-xl font-black text-white" data-id="element-140" data-mp="o630u58kv7ob">
        Antes de decidir, resolvamos tus dudas
      </h2>

      <div className="mt-5 space-y-2.5" data-id="element-141" data-mp="9bom4gw1qkfg">
        {objections.map((o, i) => {
        const isOpen = open === i;
        return <div key={o.q} className="overflow-hidden rounded-2xl border border-white/10 bg-white/5" data-id="element-142" data-mp="2tz9z0hievhai" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left" data-id="element-143" data-mp="2yzxp90ytfu3o">
                <span className="text-sm font-semibold text-white" data-id="element-144" data-mp="vp2fjxl3gb1c">{o.q}</span>
                <PlusIcon className={`h-4 w-4 shrink-0 text-teal-300 transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-145" data-mp="qrj3937yi8c1" />
              </button>
              <AnimatePresence initial={false} data-id="element-146" data-mp="hspa5mtu4038">
                {isOpen ? <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: 'easeInOut'
            }} data-id="element-147" data-mp="cri2rovlt2x3">
                    <p className="px-4 pb-4 text-sm leading-relaxed text-teal-50/80" data-id="element-148" data-mp="226pjg40x9aqo">
                      {o.a}
                    </p>
                  </motion.div> : null}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}